module.exports = __webpack_public_path__ + "static/media/fiskkit_upload.fbd36ea8.jpg";